
export default {
  props: {
    videoPath: {
      default: '',
    },
    autoplay: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      playing: false,
    }
  },
  computed: {
    tagComputed() {
      return this.videoPath.includes('youtube') ? 'iframe' : 'video'
    },
  },
}
